<template>
  <Badge
    class="saas-dashboard__plan-badge"
    bold
    :color="badgeColor"
    :size="size"
  >
    {{ $t(`workspacePlanTier.${workspaceUsage.plan_tier}`) }}
    <small v-if="workspaceUsage.trial_days_left">{{
      $t('dashboardWorkspacePlanBadge.daysLeft', {
        days: workspaceUsage.trial_days_left,
      })
    }}</small>
  </Badge>
</template>

<script>
import usage from '@saas/mixins/usage'

export default {
  name: 'DashboardWorkspacePlanBadge',
  components: {},
  mixins: [usage],
  props: {
    workspace: {
      type: Object,
      required: true,
    },
    componentArguments: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'regular',
    },
  },
  computed: {
    workspaceUsage() {
      return this.componentArguments.usageData.find(
        (u) => u.workspace_id === this.workspace.id
      )
    },
    badgeColor() {
      switch (this.workspaceUsage.plan_tier) {
        case 'free':
          return 'yellow'
        case 'premium':
          return 'cyan'
        case 'enterprise':
          return 'neutral'
        case 'advanced':
        case 'trial_advanced':
          return 'purple'
        default:
          return 'neutral'
      }
    },
  },
}
</script>
